import React, { useMemo } from "react";
import MobileSplashScreen from "./MobileSplashScreen";
import { getMediaQueryMatch, MOBILE_SPLASH_QUERY } from "./ElsaSplashVideo";

const shouldShowMobileSplash = () => getMediaQueryMatch(MOBILE_SPLASH_QUERY);

const MobileSplashGate = ({ isLoading, children }) => {
  const shouldUseSplash = useMemo(shouldShowMobileSplash, []);

  if (!shouldUseSplash) {
    return isLoading ? null : children;
  }

  if (isLoading) {
    return <MobileSplashScreen />;
  }

  return children;
};

export default MobileSplashGate;
